import { z } from 'zod';
import { blockSchema } from './blocks';
import { localizedTextSchema } from './locale';

export const chapterSchema = z
  .object({
    id: z.string().min(1),
    title: localizedTextSchema,
    blocks: z.array(blockSchema).min(1),
    requiredWidgetIds: z.array(z.string().min(1)).optional(),
    minDwellSeconds: z.number().int().nonnegative().optional(),
  })
  .strict();

export type Chapter = z.infer<typeof chapterSchema>;

/** Stored in bozp_hazard_profiles.content (JSONB). */
export const trainingContentSchema = z
  .object({
    schemaVersion: z.number().int().positive(),
    chapters: z.array(chapterSchema).min(1),
  })
  .strict();

export type TrainingContent = z.infer<typeof trainingContentSchema>;
